import { LOGOUT } from '../actionTypes';

export const logoutSession = () => ({
  type: LOGOUT,
});